import { Box, Typography } from "@mui/material";
import axios from "axios";
import Datumizo from "Components/LabIZO/Datumizo/Datumizo";
import { HStack, VStack } from "Components/LabIZO/Stackizo";
import { Accessor, ColorX, ErrorX, store } from "static";
import _ from "lodash";
import { observer } from "mobx-react";
import moment from "moment";
import PropsType from "prop-types";
import React, { Component } from "react";
import { DOMAIN } from "config/config";
import datalink from "../datalink";
import schema from "./vbschema";
import Summary from "./Summary/Summary";

class VerifyTagging extends Component {
  static propTypes = {
    docID: PropsType.string,
    doc: PropsType.object,
    onQuit: PropsType.func,
    onQuitRefresh: PropsType.func,
    addOns: PropsType.object,
  };

  static defaultProps = {
    docID: "",
    doc: {},
    onQuit: () => {},
    onQuitRefresh: () => {},
    addOns: {},
  };

  constructor() {
    super();
    this.state = {
      title: "",
      serverSidePagination: false,
      intents: [],
      base: {
        title: "",
        exportDoc: "",
        schema: schema,
        reqAuth: "",

        tablizo: {
          showSelector: false,

          columnsToolbar: false,
          filterToolbar: false,
          densityToolbar: true,
          exportToolbar: false,
        },

        Connect: {
          DBInfo: datalink.TBank.DBInfo,
          List: datalink.TBank.List,
          Get: datalink.TBank.Get,
          schema: schema.Table,
        },

        operations: {
          Edit: {
            title: "Edit TrainTagging ",
            url: datalink.TBank.Edit,
            success: "TrainTagging Edited Successfully",
            fail: "TrainTagging Edit Failed: ",
            schema: schema.Edit,
            buttons: ["Revert", "Submit"],
            onSubmit: "Edit",
          },

          Info: {
            title: "TrainTagging ",
            url: datalink.TBank.Info,
            success: "TrainTagging Load Successfully",
            fail: "TrainTagging Load Failed: ",
            schema: schema.Info,
          },
        },

        buttons: {
          inline: [],
          left: [
            {
              inject: (tableData, addOns) => this.renderLogDetails(addOns),
            },
          ],
          right: [
            {
              inject: (tableData) => (
                <HStack width={200} key="inject">
                  <Summary data={tableData} />
                </HStack>
              ),
            },
          ],
        },
      },
    };
  }

  componentDidMount() {
    this._setAllStates(() => {
      this.getAllIntents();
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (!Accessor.IsIdentical(prevProps, this.props, Object.keys(VerifyTagging.defaultProps))) {
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState(
      (state, props) => ({
        ...props,
      }),
      callback
    );
  };

  _StartTraining = async () => {
    let { doc, onQuitRefresh } = this.props;
    console.log("_StartTraining", doc);
    let url = DOMAIN + datalink.Request.Train;
    let payload = {
      JWT: store.user.JWT,
      data: doc,
    };
    await axios.post(url, payload);

    if (onQuitRefresh) onQuitRefresh();
  };

  onMountDatumizo = (callbacks) => {
    this.MountDatumizo = callbacks;
  };

  getAllIntents = async () => {
    let url = DOMAIN + "/Tables/Intent/List";
    let payload = {
      JWT: store.user.JWT,
      data: {
        skip: 0,
        limit: 9999,
        fields: ["_id"],
      },
      addOns: {
        workspace: "ALL",
        allIntents: true,
      },
    };
    try {
      let rtn = await axios.post(url, payload);
      console.log("/Tables/Intent/List", rtn.data);

      if (rtn.data.Success === true) {
        let docs = rtn.data.payload.docs;
        let intents = _.map(docs, (o, i) => {
          let splited = o._id.split(":");
          let caption = o._id;
          if (splited.length === 2) {
            caption = splited[1];
          }
          return {
            _id: o._id,
            caption: caption,
          };
        });
        this.setState((state, props) => ({
          intents: intents,
        }));
      } else {
        ErrorX.Handle(rtn.data);
      }
    } catch (e) {
      ErrorX.Handle(e);
    }
  };

  _onVerifyToggle = async (id, f) => {
    console.log(id, f);
    let { docID } = this.props;
    let url = DOMAIN + datalink.TBank.Accept;

    let payload = {
      data: {
        logID: id,
        trainID: docID,
        value: f,
        mode: "After",
      },
      JWT: store.user.JWT,
    };

    try {
      console.log(datalink.TBank.Accept, payload);

      let res = await axios.post(url, payload);

      console.log(datalink.TBank.Accept, res.data);

      if (res.data.Success === true) {
        store.Alert("Record Updated", "success");
        this.MountDatumizo.SoftReload(id);
      } else {
        store.Alert("Record Update Failed", "error");
      }
    } catch (e) {
      ErrorX.Handle(e);
    }
  };

  renderAlias() {
    let { doc } = this.props;
    return (
      <HStack justifyContent="flex-start">
        <Typography
          style={{
            textAlign: "left",
            width: "100%",
            minWidth: 500,
            fontSize: 25,
            color: ColorX.GetColorCSS("Primary"),
          }}
        >
          {doc.alias}
        </Typography>
      </HStack>
    );
  }
  renderLogDetails(addOns) {
    if (!addOns) return;
    let { doc } = addOns;
    if (!doc) return;
    return (
      <HStack key="details" justifyContent="flex-start" gap={50} width="fit-content">
        <Typography
          style={{
            textAlign: "left",
            fontSize: 16,
            color: ColorX.GetColorCSS("dark"),
          }}
        >
          {doc.logPeriod && "Log Period: " + moment(doc.logPeriod.from).format("DD/MM/YYYY") + " - " + moment(doc.logPeriod.to).format("DD/MM/YYYY")}
        </Typography>
        <Typography
          style={{
            textAlign: "left",
            fontSize: 16,
            color: ColorX.GetColorCSS("dark"),
          }}
        >
          {"Sample Size: " + (doc.sampleSize * 100 + "%")}
        </Typography>
      </HStack>
    );
  }
  render() {
    let { base, serverSidePagination, title, addOns, intents } = this.state;
    let { docID, doc } = this.props;
    let ModaddOns = {
      ...addOns,
      trainID: docID,
      onVerifyToggle: this._onVerifyToggle,
      intents: intents,
      doc,
    };
    return (
      <VStack width="100%">
        <Box width="100%">
          <Typography
            style={{
              textAlign: "left",
              width: "100%",
              fontSize: 25,
              color: ColorX.GetColorCSS("Primary"),
            }}
          >
            {title}
          </Typography>
        </Box>

        {/* Scnerio Name */}
        <Box padding={1} width="100%">
          <VStack alignItems="flex-start">{this.renderAlias()}</VStack>
        </Box>
        <Datumizo base={base} onMounted={this.onMountDatumizo} serverSidePagination={serverSidePagination} refreshOnPageChange={false} addOns={ModaddOns} languageSelector={false} />
      </VStack>
    );
  }
}

export default observer(VerifyTagging);
